// extracted by mini-css-extract-plugin
module.exports = {"default":"tooltip_default__AEZP7","title":"tooltip_title__eGESz","content":"tooltip_content__u5wgl"};